import { Validator } from "./validator";

const ITEM_CODE = {
  ORGANIZATION_NAME: "01",
  OWNER_USER_NAME: "02",
  PASSWORD: "03",
  BLLING_ADDRESS_COMPANY_NAME: "04",
  BLLING_PERSON_IN_CHARGE: "05",
  BLLING_ADDRESS_POSTAL_CODE: "06",
  BLLING_ADDRESS_STATE: "07",
  BLLING_ADDRESS_TOWN: "08",
  BLLING_ADDRESS_STREET: "09",
  BLLING_ADDRESS_BUILDING: "10",
  BLLING_ADDRESS_PHONE_NUMBER: "11",
};

// 名称のデフォルト最大文字数
const MAX_ORGANIZATION_NAME_LENGTH = 20;
const MAX_OWNER_USER_NAME_LENGTH = 20;
const MAX_COMPANY_NAME_LENGTH = 20;
const MAX_PERSON_IN_CHARGE_NAME_LENGTH = 20;
const MAX_POSTAL_CODE_LENGTH = 20;

class OrganizationValidator extends Validator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();

    this.errors.organizationId = [];
    this.errors.name = [];
    this.errors.ownerUserId = [];
    this.errors.ownerUserEmail = [];
    this.errors.ownerUserName = [];
    this.errors.password = [];

    this.errors.spaceKey = [];
    this.errors.planTypeCd = [];
    this.errors.version = [];

    this.errors.billingAddressCompanyName = [];
    this.errors.billingAddressPersonInChargeName = [];
    this.errors.billingAddressPostalCode = [];
    this.errors.billingAddressState = [];
    this.errors.billingAddressTown = [];
    this.errors.billingAddressStreet = [];
    this.errors.billingAddressBuilding = [];
    this.errors.billingAddressPhoneNumber = [];

    this.errors.paymentInfoPaymentMethod = [];
  }
  /* eslint-enable */
}

class OrganizationSignUpValidator extends OrganizationValidator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();
  }
  /* eslint-enable */

  static validate(organization, passwrod1, password2) {
    const validator = new OrganizationSignUpValidator();

    // アカウント名
    validator.checkName(
      "name",
      organization.name,
      "アカウント名",
      ITEM_CODE.ORGANIZATION_NAME,
      {
        maxSize: MAX_ORGANIZATION_NAME_LENGTH,
      },
    );

    // 契約ユーザ名
    validator.checkName(
      "ownerUserName",
      organization.ownerUserName,
      "ユーザー名",
      ITEM_CODE.OWNER_USER_NAME,
      {
        size: MAX_OWNER_USER_NAME_LENGTH,
      },
    );
    validator.checkPassword("password", passwrod1, password2, "パスワード", ITEM_CODE.PASSWORD);

    // 請求情報（社名）
    validator.checkName(
      "billingAddressCompanyName",
      organization.billingAddress.companyName,
      "社名",
      ITEM_CODE.BLLING_ADDRESS_COMPANY_NAME,
      {
        maxSize: MAX_COMPANY_NAME_LENGTH,
      },
    );

    // 請求情報（ご担当者名）
    validator.checkName(
      "billingAddressPersonInChargeName",
      organization.billingAddress.personInChargeName,
      "ご担当者名",
      ITEM_CODE.BLLING_PERSON_IN_CHARGE,
      {
        maxSize: MAX_PERSON_IN_CHARGE_NAME_LENGTH,
      },
    );

    // 請求情報（住所）　- 郵便番号
    validator.checkPostalCode(
      "billingAddressPostalCode",
      organization.billingAddress.postalCode,
      "郵便番号",
      ITEM_CODE.BLLING_ADDRESS_POSTAL_CODE,
      {
        maxSize: MAX_POSTAL_CODE_LENGTH,
      },
    );

    // 請求情報（住所）　-　都道府県
    validator.checkStateName(
      "billingAddressState",
      organization.billingAddress.state,
      "都道府県",
      ITEM_CODE.BLLING_ADDRESS_STATE,
    );

    // 請求情報（住所）　-　市区町村
    validator.checkTownName(
      "billingAddressTown",
      organization.billingAddress.town,
      "市区町村",
      ITEM_CODE.BLLING_ADDRESS_TOWN,
    );

    // 請求情報（住所）　-　番地
    validator.checkStreetText(
      "billingAddressStreet",
      organization.billingAddress.street,
      "番地",
      ITEM_CODE.BLLING_ADDRESS_STREET,
    );

    // 請求情報（住所）　-　ビル・建物名
    validator.checkBuildingText(
      "billingAddressBuilding",
      organization.billingAddress.building,
      "ビル・建物名",
      ITEM_CODE.BLLING_ADDRESS_BUILDING,
    );

    // 請求情報（ご連絡先電話番号）
    validator.checkPhoneNumber(
      "billingAddressPhoneNumber",
      organization.billingAddress.phoneNumber,
      "ご連絡先電話番号",
      ITEM_CODE.BLLING_ADDRESS_PHONE_NUMBER,
    );

    return validator;
  }
}

class OrganizationsUpdateValidator extends OrganizationValidator {
  /* eslint-disable no-unused-expressions */
  constructor() {
    super();
  }
  /* eslint-enable */

  static validate(organization) {
    const validator = new OrganizationsUpdateValidator();

    // アカウント名
    validator.checkName(
      "name",
      organization.name,
      "アカウント名",
      ITEM_CODE.ORGANIZATION_NAME,
      {
        maxSize: MAX_ORGANIZATION_NAME_LENGTH,
      },
    );

    // 契約ユーザ名
    validator.checkName(
      "ownerUserName",
      organization.ownerUserName,
      "ユーザー名",
      ITEM_CODE.OWNER_USER_NAME,
      {
        size: MAX_OWNER_USER_NAME_LENGTH,
      },
    );

    // 請求情報（社名）
    validator.checkName(
      "billingAddressCompanyName",
      organization.billingAddress.companyName,
      "請求情報（社名）",
      ITEM_CODE.BLLING_ADDRESS_COMPANY_NAME,
      {
        maxSize: MAX_COMPANY_NAME_LENGTH,
      },
    );

    // 請求情報（ご担当者名）
    validator.checkName(
      "billingAddressPersonInChargeName",
      organization.billingAddress.personInChargeName,
      "ご担当者名",
      ITEM_CODE.BLLING_PERSON_IN_CHARGE,
      {
        maxSize: MAX_PERSON_IN_CHARGE_NAME_LENGTH,
      },
    );

    // 請求情報（住所）　- 郵便番号
    validator.checkPostalCode(
      "billingAddressPostalCode",
      organization.billingAddress.postalCode,
      "郵便番号",
      ITEM_CODE.BLLING_ADDRESS_POSTAL_CODE,
      {
        maxSize: MAX_POSTAL_CODE_LENGTH,
      },
    );

    // 請求情報（住所）　-　都道府県
    validator.checkStateName(
      "billingAddressState",
      organization.billingAddress.state,
      "都道府県",
      ITEM_CODE.BLLING_ADDRESS_STATE,
    );

    // 請求情報（住所）　-　市区町村
    validator.checkTownName(
      "billingAddressTown",
      organization.billingAddress.town,
      "市区町村",
      ITEM_CODE.BLLING_ADDRESS_TOWN,
    );

    // 請求情報（住所）　-　番地
    validator.checkStreetText(
      "billingAddressStreet",
      organization.billingAddress.street,
      "番地",
      ITEM_CODE.BLLING_ADDRESS_STREET,
    );

    // 請求情報（住所）　-　ビル・建物名
    validator.checkBuildingText(
      "billingAddressBuilding",
      organization.billingAddress.building,
      "ビル・建物名",
      ITEM_CODE.BLLING_ADDRESS_BUILDING,
    );

    // 請求情報（ご連絡先電話番号）
    validator.checkPhoneNumber(
      "billingAddressPhoneNumber",
      organization.billingAddress.phoneNumber,
      "ご連絡先電話番号",
      ITEM_CODE.BLLING_ADDRESS_PHONE_NUMBER,
    );

    return validator;
  }
}

export {
  OrganizationValidator,
  OrganizationSignUpValidator,
  OrganizationsUpdateValidator,
};
